import {createRouter, createWebHistory} from 'vue-router';
import Swal from "sweetalert2";


import SplashPage from "@/components/SplashPage.vue";
import LoginPage from "@/components/LoginPage.vue";
import OtpPage from "@/components/OtpPage.vue";
import RegisterPage from "@/components/RegisterPage.vue";
import HomePage from "@/components/HomePage.vue";
import AddProducts from "@/components/AddProducts.vue";
import ProductsPage from "@/components/ProductsPage.vue";
import WebPage from "@/components/WebPage.vue";
import ProductProposal from "@/components/ProductProposal.vue";
import MyOrders from "@/components/MyOrders.vue";
import SupportPage from "@/components/SupportPage.vue";
import MyTickets from "@/components/MyTickets.vue";
import DetailsProducts from "@/components/DetailsProducts.vue";
import DetailsOrder from "@/components/DetailsOrder.vue";
import WalletPage from "@/components/WalletPage.vue";
import MyAuctions from "@/components/MyAuctions.vue";
import AddAuctions from "@/components/AddAuctions.vue";
import AuctionInformation from "@/components/AuctionInformation.vue";
import OffersPage from "@/components/OffersPage.vue";
import ReportingPage from "@/components/ReportingPage.vue";
import ProductsManagement from "@/components/ProductsManagement.vue";
import ProfileEdit from "@/components/ProfileEdit.vue";

const routes = [
    { path: '/', name: 'SplashPage', component: SplashPage },
    { path: '/LoginPage', name: 'LoginPage', component: LoginPage },
    { path: '/OtpPage/:phone', name: 'OtpPage', component: OtpPage },
    { path: '/HomePage', name: 'HomePage', component: HomePage },
    { path: '/RegisterPage/:phone', name: 'RegisterPage', component: RegisterPage },
    { path: '/ProductsManagement', name: 'ProductsManagement', component: ProductsManagement },
    { path: '/AddProducts/:action', name: 'AddProducts', component: AddProducts },
    { path: '/ProductsPage/:sub_id/:sub_name', name: 'ProductsPage', component: ProductsPage },
    { path: '/WebPage/:type', name: 'WebPage', component: WebPage },
    { path: '/ProductProposal', name: 'ProductProposal', component: ProductProposal },
    { path: '/MyOrders', name: 'MyOrders', component: MyOrders },
    { path: '/SupportPage', name: 'SupportPage', component: SupportPage },
    { path: '/MyTickets', name: 'MyTickets', component: MyTickets },
    { path: '/DetailsProducts/:pid', name: 'DetailsProducts', component: DetailsProducts },
    { path: '/DetailsOrder/:oid', name: 'DetailsOrder', component: DetailsOrder },
    { path: '/WalletPage', name: 'WalletPage', component: WalletPage },
    { path: '/MyAuctions', name: 'MyAuctions', component: MyAuctions },
    { path: '/AddAuctions', name: 'AddAuctions', component: AddAuctions },
    { path: '/AuctionInformation/:bid', name: 'AuctionInformation', component: AuctionInformation },
    { path: '/OffersPage', name: 'OffersPage', component: OffersPage },
    { path: '/ReportingPage', name: 'ReportingPage', component: ReportingPage },
    { path: '/ProfileEdit', name: 'ProfileEdit', component: ProfileEdit },
]


const router = createRouter({
    history: createWebHistory(),
    routes
})

let user_id = localStorage.getItem('sid')

router.beforeEach((to, from, next) => {
    Swal.close()

    if (!user_id && to.name !== 'LoginPage' && to.name !== 'OtpPage' && to.name !== 'RegisterPage' && to.name !== 'SplashPage' && to.name !== 'InformationPage' ) {
        next({ name: 'SplashPage' })
    } else {
        next()
    }
})


export default router;